import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "zdrojFull",
  kodKey: "nazev",
  nazevKey: "popis",
  placeholderText: "VZO"
});
